/** The Sales Partner program lives on evinitiative.com (Warren, 8 Oct 2026:
 *  its application is the better intake form), so every Sales Partner link on
 *  the shop goes there, in the same tab. */
export const PARTNERS_URL = 'https://evinitiative.com/partners';
export const HOSTS_URL = 'https://evinitiative.com/hosts';
export const PRICING_URL = 'https://evinitiative.com/pricing';

/** The application form on that page. */
export const PARTNERS_APPLY_URL = 'https://evinitiative.com/partners#start';
